var SolidFillStyle = /** @class */ (function () {
    function SolidFillStyle(color, alpha) {
        if (color === void 0) { color = 0xffffff; }
        if (alpha === void 0) { alpha = 1; }
        this.color = color;
        this.alpha = alpha;
    }
    SolidFillStyle.prototype.getUVMatrix = function () {
        return this.uvMatrix;
    };
    Object.defineProperty(SolidFillStyle.prototype, "data_type", {
        get: function () {
            return SolidFillStyle.data_type;
        },
        enumerable: false,
        configurable: true
    });
    SolidFillStyle.prototype.toString = function () {
        return (this.color | 0).toString(16) + '#' + ((this.alpha * 255) | 0).toString(16);
    };
    SolidFillStyle.data_type = '[graphicsdata SolidFillStyle]';
    return SolidFillStyle;
}());
export { SolidFillStyle };
